/* eslint-disable no-param-reassign */
import {
  User,
  Role,
  LevelDBDataSource,
  DataSource,
} from '@fulcrumapp/fulcrum-core';
import { createSlice } from '@reduxjs/toolkit';
import LocalStoragePreferences from '../utils/local-storage-preferences';
import LayerSettings from '../models/layer-settings';
import { Globals } from '../models/globals';
import { Role as RestRole } from '../models/role';
import { User as RestUser } from '../models/user';
import Client from '../api/client';
import {
  appApiDatasourceReducer,
  appGlobalsReducer,
  appRestUserReducer,
  appRestRoleReducer,
  appRoleReducer,
  appUserReducer,
  appLayerSettingsReducer,
  appPreferencesReducer,
  appParamsReducer,
} from './reducers';
import appInitialState from './app-initial-state';

export interface AppState extends ApiAndDataSource{
  globals?: Globals;
  layerSettings?: LayerSettings;
  preferences?: LocalStoragePreferences;
  restRole?: RestRole;
  restUser?: RestUser;
  role?: Role;
  user?: User;
  params?: any;
}

export interface ApiAndDataSource {
  api?: Client | null;
  dataSource?: DataSource | null;
  objectCache?: LevelDBDataSource | null;
}

export const appSlice = createSlice({
  name: 'app',
  initialState: appInitialState(),
  reducers: {
    setApiDatasource: (state, action) => { appApiDatasourceReducer(state as any, action); },
    setGlobals: (state, action) => { appGlobalsReducer(state, action); },
    setLayerSettings: (state, action) => { appLayerSettingsReducer(state, action); },
    setParams: (state, action) => { appParamsReducer(state, action); },
    setPreferences: (state, action) => { appPreferencesReducer(state, action); },
    setRestRole: (state, action) => { appRestRoleReducer(state, action); },
    setRestUser: (state, action) => { appRestUserReducer(state, action); },
    setRole: (state, action) => { appRoleReducer(state, action); },
    setUser: (state, action) => { appUserReducer(state, action); },
  },
});

export const selectAppState = (state: any) => ({ ...state.app });

export const {
  setApiDatasource,
  setGlobals,
  setLayerSettings,
  setParams,
  setPreferences,
  setRestRole,
  setRestUser,
  setRole,
  setUser,
} = appSlice.actions;

export default appSlice.reducer;
